<template>
    <v-container class="fill-height d-flex justify-center align-center">
      <v-card class="pa-5" max-width="500" width="100%">
        <v-card-title class="text-center text-h5 mb-4">
          E-posta Doğrulama Sonucu
        </v-card-title>
        <v-card-text>
          <v-alert v-if="loading" type="info" prominent :border="left">
            Doğrulama işleniyor...
          </v-alert>
          <v-alert v-else-if="success" type="success" prominent :border="left">
            E-posta adresiniz başarıyla doğrulandı! Şimdi giriş yapabilirsiniz.
          </v-alert>
          <v-alert v-else type="error" prominent :border="left">
            {{ errorMessage }}
          </v-alert>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" to="/login">
            Giriş Sayfasına Git
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'VerificationResult',
    data() {
      return {
        loading: false, // Initially false, backend handles redirect
        success: false,
        errorMessage: 'E-posta doğrulaması başarısız oldu. Lütfen tekrar deneyin veya destek ile iletişime geçin.',
      };
    },
    created() {
      // Backend redirects here with query parameters
      const query = this.$route.query;
      this.success = query.success === 'true';
  
      if (!this.success) {
        switch (query.message) {
          case 'invalid_token':
            this.errorMessage = 'Geçersiz doğrulama bağlantısı.';
            break;
          case 'invalid_or_expired_token':
            this.errorMessage = 'Doğrulama bağlantısı geçersiz veya süresi dolmuş. Lütfen yeni bir doğrulama e-postası isteyin.';
            break;
          case 'server_error':
            this.errorMessage = 'Doğrulama sırasında bir sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.';
            break;
          default:
            // Keep default error message
            break;
        }
      }
    },
  };
  </script>
  
  <style scoped>
  /* Add styles if needed */
  </style>
  